import { render, staticRenderFns } from "./EstateAdministrationCostCalculator.vue?vue&type=template&id=646ffa73&scoped=true"
import script from "./EstateAdministrationCostCalculator.vue?vue&type=script&lang=js"
export * from "./EstateAdministrationCostCalculator.vue?vue&type=script&lang=js"
import style0 from "./EstateAdministrationCostCalculator.vue?vue&type=style&index=0&id=646ffa73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ffa73",
  null
  
)

export default component.exports